import axios from 'axios';
import { API_URL } from '../../Api/api';

export const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

export const sendForgotOtp = (email) =>
  axios.post(`${API_URL}/admin/forgot-password-otp`, { email: normalizeEmail(email) });

export const verifyForgotOtp = (email, otp) =>
  axios.post(`${API_URL}/admin/verify-otp`, {
    email: normalizeEmail(email),
    otp: String(otp || '').trim(),
  });

export const resetForgotPassword = (email, newPassword) =>
  axios.post(`${API_URL}/admin/reset-password`, {
    email: normalizeEmail(email),
    new_password: newPassword,
  });

export const handleOtpSendResponse = (res, toast) => {
  if (res.data?.otp_dev) {
    toast.info(`Dev OTP: ${res.data.otp_dev}`);
  }
  toast.success(res.data?.message || 'OTP sent to email');
};
